import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import PaymentMethods from './views/payment-methods'
import IChargeNews from './views/i-charge-news'
import IchargePlatform from './views/icharge-platform'
import IChargeRoaming from './views/i-charge-roaming'
import HomeEn from './views/home-en'
import Services from './views/services'
import HelpCenter from './views/help-center'
import TermsAndConditions from './views/terms-and-conditions'
import HomeAl from './views/home-al'
import WhoCanBenefit from './views/who-can-benefit'
import NotFound from './views/not-found'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={PaymentMethods} exact path="/payment-methods" />
        <Route component={IChargeNews} exact path="/i-charge-news" />
        <Route component={IchargePlatform} exact path="/icharge-platform" />
        <Route component={IChargeRoaming} exact path="/i-charge-roaming" />
        <Route component={HomeEn} exact path="/" />
        <Route component={Services} exact path="/services" />
        <Route component={HelpCenter} exact path="/help-center" />
        <Route
          component={TermsAndConditions}
          exact
          path="/terms-and-conditions"
        />
        <Route component={HomeAl} exact path="/home-al" />
        <Route component={WhoCanBenefit} exact path="/who-can-benefit" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
